import { Key, MAJOR_SCALE, MINOR_SCALE, Scale } from '@arpeggi/shared'
import AbstractObservable from './AbstractObservable'
import { NOTE_COUNT, NOTE_HEIGHT } from './PianoRollUtils'

export interface KeyAndScale {
  key: Key
  scale: Scale
}

const initialState: KeyAndScale = {
  key: Key.C,
  scale: Scale.CHROMATIC
}

class KeyScaleManager extends AbstractObservable<KeyAndScale> {
  private visibleToGlobal: Array<number>
  private globalToVisible: Array<number>
  visibleNotes: number

  constructor(initial = initialState) {
    super(initial)
    this._calculateMapping(this.state)
  }

  private _calculateMapping({ key, scale }: KeyAndScale) {
    if (scale === Scale.CHROMATIC) {
      this.visibleToGlobal = new Array(NOTE_COUNT).fill(0).map((_, i) => i)
      this.globalToVisible = [...this.visibleToGlobal]
      this.visibleNotes = NOTE_COUNT
      return
    }
    this.visibleToGlobal = new Array(NOTE_COUNT)
    this.globalToVisible = new Array(NOTE_COUNT)
    const _scale = scale === Scale.MAJOR ? MAJOR_SCALE : MINOR_SCALE
    let vi = 0
    for (let gi = 0; gi < NOTE_COUNT; gi++) {
      if (_scale[(gi - key + 12) % 12]) {
        this.visibleToGlobal[vi] = gi
        this.globalToVisible[gi] = vi
        vi++
      }
    }
    this.visibleNotes = vi
  }

  yToNote(y: number, floor = false) {
    if (floor) return this.visibleToGlobal[this.visibleNotes - 1 - Math.floor(y / NOTE_HEIGHT)]
    return this.visibleToGlobal[this.visibleNotes - 1 - Math.round(y / NOTE_HEIGHT)]
  }

  noteToY(note: number) {
    return (this.visibleNotes - 1 - this.globalToVisible[note]) * NOTE_HEIGHT
  }

  override update(value: KeyAndScale): void {
    this._calculateMapping(value)
    super.update(value)
  }

  protected override notifySubscribers(): void {
    requestAnimationFrame(super.notifySubscribers.bind(this))
  }
}

export default new KeyScaleManager()
